import { useMutation } from '@tanstack/react-query'

import type { MutationFeedback } from '@/integrations/tanstack-query/types'
import { apiClient } from '@/lib/api-client'

export const CANCEL_ENVELOPE_QUERY_KEYS = [
  'envelopes',
  'envelope',
  'vault-items',
]

export const cancelEnvelope = async (envelopeId: string): Promise<void> => {
  await apiClient.post(`/v1/ecm/envelopes/${envelopeId}/cancel`)
}

export const useCancelEnvelope = (feedback?: MutationFeedback) => {
  return useMutation({
    mutationFn: (envelopeId: string) => cancelEnvelope(envelopeId),
    meta: {
      invalidatesQuery: CANCEL_ENVELOPE_QUERY_KEYS,
      ...feedback,
    },
  })
}
